import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxFillAlertsList } from "../../Apis/AuthApiServices";
import {
  loadingRxFillAlertsDetails,
  setRxFillAlertsDetails,
} from "../Slice/RxFillAlertsDetailsSlice";

function* onLoadRxFillAlertsDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  const doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("selectedUserId", payload.docId);
  try {
    const result: AxiosResponse = yield RxFillAlertsList(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxFillAlertsDetails({
          RxFillAlertsDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxFillAlertsDetails({
          RxFillAlertsDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxFillAlertsDetails({
        RxFillAlertsDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxFillAlertsDetails() {
  yield takeLatest(
    loadingRxFillAlertsDetails.type,
    onLoadRxFillAlertsDetailsAsync
  );
}

const RxFillAlertsDetailsSaga = [fork(onLoadRxFillAlertsDetails)];
export default RxFillAlertsDetailsSaga;
